<template>
  <div style="width : 100%;">
    <CategoryPageContent />
  </div>
</template>

<script>
import CategoryPageContent from "@/esf_antarctica_lederhosenland/core/components/category-product/CategoryPageContent.vue";
export default {
  name: "ProductListingV2",
  components: {
    CategoryPageContent,
  },
  computed: {
    category() {
      return this.$store.getters["category/getCurrentCategory"];
    },
    bestsellers() {
      return this.$store.getters["category/getBestSellersSimple"];
    },
  },
};
</script>

<style lang="scss" scoped>
h3,
.h3 {
  font-weight: 400;
  margin-bottom: 10px;
}

.bottom-txt {
  font-size: 12px;
  line-height: 1.72;
  padding-bottom: 14px;
  // padding-top: 25px;
}
.category-name-right {
  font-size: 16px;
  font-weight: 600;
}
</style>
